import { render, staticRenderFns } from "./Widgets.vue?vue&type=template&id=503a4a58&lang=pug&"
import script from "./Widgets.vue?vue&type=script&lang=js&"
export * from "./Widgets.vue?vue&type=script&lang=js&"
import style0 from "./Widgets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports